import { useEffect, useMemo, useState } from "react";
import { Dialog } from "@mui/material";
import { ModalCloseButton } from "../../../../Components/Molecules/ValutDialog";
import {
  handleBussinessTaxIDInput,
  handleTaxIDInput,
  phoneMask,
} from "../../../../Utils/masks";
import { PIX_KEY_TYPES } from "./constants";

const inputClass =
  "h-10 w-full rounded-lg border border-gray-200 px-3 text-sm text-brand-dark outline-none transition focus:border-[#e7a73f]";

export const PixKeyCreateModal = ({
  open,
  onClose,
  onSubmit,
  submitting = false,
  accountData = {},
}) => {
  const [selectedType, setSelectedType] = useState("email");
  const [value, setValue] = useState("");

  const typeMeta = useMemo(
    () => PIX_KEY_TYPES.find((item) => item.id === selectedType),
    [selectedType]
  );

  useEffect(() => {
    if (!open) {
      setSelectedType("email");
      setValue("");
      return;
    }

    if (selectedType === "cpf" && accountData.userDocument) {
      setValue(accountData.userDocument);
    }
  }, [open, selectedType, accountData.userDocument]);

  const handleTypeChange = (typeId) => {
    setSelectedType(typeId);
    if (typeId === "cpf" && accountData.userDocument) {
      setValue(accountData.userDocument);
      return;
    }
    setValue("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!typeMeta) return;
    if (!typeMeta.autoGenerate && !value.trim()) return;

    const success = await onSubmit({
      type: typeMeta.apiType,
      value: typeMeta.autoGenerate ? "" : value.trim(),
    });

    if (success) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ className: "!rounded-2xl !shadow-card" }}
    >
      <form onSubmit={handleSubmit} className="relative px-5 py-6 sm:px-6">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3" disabled={submitting} />
        <h2 className="pr-8 text-lg font-bold text-brand-dark">Cadastrar chave Pix</h2>
        <p className="mt-1 text-sm text-gray-500">
          Escolha o tipo de chave e informe os dados para receber pagamentos.
        </p>

        <div className="mt-5">
          <p className="mb-2 text-xs font-medium text-gray-500">Tipo de chave</p>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
            {PIX_KEY_TYPES.map((type) => {
              const Icon = type.icon;
              const isActive = selectedType === type.id;
              return (
                <button
                  key={type.id}
                  type="button"
                  onClick={() => handleTypeChange(type.id)}
                  className={`flex flex-col items-center gap-1.5 rounded-xl border px-3 py-3 text-center transition ${
                    isActive
                      ? "border-[#e7a73f] bg-brand-cream text-brand-dark"
                      : "border-gray-200 bg-white text-gray-500 hover:border-gray-300"
                  }`}
                >
                  <Icon className="h-5 w-5" />
                  <span className="text-[11px] font-semibold leading-tight">{type.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="mt-5">
          {typeMeta?.autoGenerate ? (
            <div className="rounded-xl border border-gray-100 bg-gray-50 px-4 py-3 text-sm text-gray-600">
              Uma chave aleatória será gerada automaticamente pelo sistema após a confirmação.
            </div>
          ) : (
            <label className="block">
              <span className="mb-1.5 block text-xs font-medium text-gray-500">
                {typeMeta?.label}
              </span>
              <input
                type={selectedType === "email" ? "email" : "text"}
                value={value}
                onChange={(e) => {
                  const next = e.target.value;
                  if (selectedType === "phone") {
                    setValue(phoneMask(next));
                    return;
                  }
                  if (selectedType === "cpf") {
                    setValue(handleTaxIDInput(next));
                    return;
                  }
                  if (selectedType === "cnpj") {
                    setValue(handleBussinessTaxIDInput(next));
                    return;
                  }
                  setValue(next);
                }}
                placeholder={typeMeta?.placeholder}
                className={inputClass}
                required
              />
            </label>
          )}
        </div>

        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button type="submit" className="btn-primary w-full sm:w-auto" disabled={submitting}>
            {submitting ? "Cadastrando..." : "Cadastrar chave"}
          </button>
        </div>
      </form>
    </Dialog>
  );
};
